<div class="timeline-container">
    <!-- Controls -->
    <div class="controls">
      <button class="control-btn" (click)="zoomOut()">-</button>
      <span class="current-time">{{ startDate | date: 'MMM dd' }} - {{ endDate | date: 'MMM dd' }}</span>
      <button class="control-btn" (click)="zoomIn()">+</button>
      <button class="download-btn">Download All</button>
    </div>
  
    <!-- Horizontal Timeline -->
    <div class="horizontal-timeline">
      <div class="day-label" *ngFor="let day of timelineData">
        <div>{{ day.date | date: 'MMM dd' }}</div>
  
        <!-- Scale with events -->
        <div class="time-scale">
          <div *ngFor="let hour of day.hours" class="time-slot">
            <span class="hour-label">{{ hour.time }}</span>
            <div *ngFor="let marker of generateQuarterMarkers()" class="quarter-marker" [style.left]="marker"></div>
            <!-- Vertical Event Line -->
            <div
              class="event-line"
              *ngFor="let event of hour.events"
              [style.left]="event.position"
              (mouseenter)="showPopup(event)"
              (mouseleave)="hidePopup()"
              (click)="showDetails(event)"
            >
                <div *ngIf="hoveredEvent === event" class="hover-popup">
                    <img [src]="event.image" alt="Event Image" />
                    <p>{{ event.details }}</p>
                </div>
                <div class="checkbox-container">
                    <input
                      type="checkbox"
                      [checked]="event.selected"
                      (change)="toggleEventSelection(event, $event)"
                    />
                  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="selectedEvent" class="click-popup">
        <div class="popup-content">
          <img [src]="selectedEvent.image" alt="Event Image" />
          <p>{{ selectedEvent.details }}</p>
          <button (click)="closePopup()">Close</button>
        </div>
      </div>
  </div>
  